export default {
  metadata: {
    version: '2.0.0',
    id: 'avatar-notification-2.0.0',
    name: 'JDSAvatarV2Notification'
  },
  hierarchy: {
    container: [
      'jds_avatar_v2_default',
      {
        'badge-container': ['jds_badge_v2']
      }
    ]
  },
  base: {
    container: {
      'flex-direction': '{flexDirection.stack}',
      'justify-content': '{justifyContent.start}',
      'align-items': '{alignItems.end}',
      opacity: '{opacity.enabled}'
    },
    'badge-container': {
      'padding-left': 28,
      'padding-bottom': 28,
      'z-index': 1,
      disabled: true
    },
    jds_avatar_v2_default: {
      size: 'medium'
    },
    jds_badge_v2: {
      kind: 'notification',
      notificationKind: 'dot',
      size: 'small'
    }
  },
  variant: {
    kind: {
      number: {
        jds_badge_v2: {
          notificationKind: 'number'
        }
      },
      'number-symbol': {
        jds_badge_v2: {
          notificationKind: 'number-symbol'
        }
      }
    },
    disabled: {
      true: {
        container: {
          disabled: true,
          opacity: '{opacity.disabled}'
        }
      }
    }
  },
  combination: [
    {
      'xtra-small': {
        dot: {
          'badge-container': {
            'padding-left': 16,
            'padding-bottom': 16
          },
          jds_avatar_v2_default: {
            size: 'xtra-small'
          },
          jds_badge_v2: {
            size: 'xtra-small'
          }
        },
        number: {
          'badge-container': {
            'padding-left': '{base}',
            'padding-bottom': '{base}'
          },
          jds_avatar_v2_default: {
            size: 'xtra-small'
          },
          jds_badge_v2: {
            size: 'xtra-small'
          }
        },
        'number-symbol': {
          'badge-container': {
            'padding-left': '{base}',
            'padding-bottom': '{base}'
          },
          jds_avatar_v2_default: {
            size: 'xtra-small'
          },
          jds_badge_v2: {
            size: 'xtra-small'
          }
        }
      },
      small: {
        dot: {
          'badge-container': {
            'padding-left': '{m}',
            'padding-bottom': '{m}'
          },
          jds_avatar_v2_default: {
            size: 'small'
          },
          jds_badge_v2: {
            size: 'xtra-small'
          }
        },
        number: {
          'badge-container': {
            'padding-left': 20,
            'padding-bottom': 20
          },
          jds_avatar_v2_default: {
            size: 'small'
          },
          jds_badge_v2: {
            size: 'small'
          }
        },
        'number-symbol': {
          'badge-container': {
            'padding-left': 20,
            'padding-bottom': 22
          },
          jds_avatar_v2_default: {
            size: 'small'
          },
          jds_badge_v2: {
            size: 'small'
          }
        }
      },
      medium: {
        number: {
          'badge-container': {
            'padding-left': 28,
            'padding-bottom': 28
          },
          jds_avatar_v2_default: {
            size: 'medium'
          },
          jds_badge_v2: {
            size: 'small'
          }
        },
        'number-symbol': {
          'badge-container': {
            'padding-left': '{m}',
            'padding-bottom': 28
          },
          jds_avatar_v2_default: {
            size: 'medium'
          },
          jds_badge_v2: {
            size: 'small'
          }
        }
      },
      large: {
        dot: {
          'badge-container': {
            'padding-left': '{l}',
            'padding-bottom': '{l}'
          },
          jds_avatar_v2_default: {
            size: 'large'
          },
          jds_badge_v2: {
            size: 'medium'
          }
        },
        number: {
          'badge-container': {
            'padding-left': '{l}',
            'padding-bottom': '{l}'
          },
          jds_avatar_v2_default: {
            size: 'large'
          },
          jds_badge_v2: {
            size: 'medium'
          }
        },
        'number-symbol': {
          'badge-container': {
            'padding-left': 28,
            'padding-bottom': 36
          },
          jds_avatar_v2_default: {
            size: 'large'
          },
          jds_badge_v2: {
            size: 'medium'
          }
        }
      },
      'xtra-large': {
        dot: {
          'badge-container': {
            'padding-left': '{xl}',
            'padding-bottom': '{xl}'
          },
          jds_avatar_v2_default: {
            size: 'xtra-large'
          },
          jds_badge_v2: {
            size: 'medium'
          }
        },
        number: {
          'badge-container': {
            'padding-left': 36,
            'padding-bottom': 36
          },
          jds_avatar_v2_default: {
            size: 'xtra-large'
          },
          jds_badge_v2: {
            size: 'medium'
          }
        },
        'number-symbol': {
          'badge-container': {
            'padding-left': 36,
            'padding-bottom': '{xl}'
          },
          jds_avatar_v2_default: {
            size: 'xtra-large'
          },
          jds_badge_v2: {
            size: 'medium'
          }
        }
      },
      'xtra-xtra-large': {
        dot: {
          'badge-container': {
            'padding-left': 88,
            'padding-bottom': 88
          },
          jds_avatar_v2_default: {
            size: 'xtra-xtra-large'
          },
          jds_badge_v2: {
            size: 'xtra-large'
          }
        },
        number: {
          'badge-container': {
            'padding-left': 88,
            'padding-bottom': 88
          },
          jds_avatar_v2_default: {
            size: 'xtra-xtra-large'
          },
          jds_badge_v2: {
            size: 'large'
          }
        },
        'number-symbol': {
          'badge-container': {
            'padding-left': 72,
            'padding-bottom': 88
          },
          jds_avatar_v2_default: {
            size: 'xtra-xtra-large'
          },
          jds_badge_v2: {
            size: 'large'
          }
        }
      }
    }
  ],
  combination_config: [['size', 'kind']],
  api: {
    config: {
      kind: {
        values: ['dot', 'number', 'number-symbol']
      },
      size: {
        values: [
          'medium',
          'xtra-small',
          'small',
          'large',
          'xtra-large',
          'xtra-xtra-large'
        ]
      },
      disabled: {
        values: [false, true]
      }
    },
    data: {
      jds_avatar_v2_default: {
        image: {
          type: 'image',
          name: 'avatarImage'
        },
        initials: {
          type: 'string',
          name: 'avatarInitials'
        },
        kind: {
          type: 'JDSAvatarV2Default.kind',
          name: 'avatarKind'
        }
      },
      jds_badge_v2: {
        label: {
          type: 'string',
          name: 'label'
        }
      }
    },
    a11y: {
      container: {
        properties: {
          'aria-label': {
            name: 'ariaLabel',
            value: 'Avatar with Active Notifications'
          },
          'aria-describedby': {
            name: 'ariaDescribedby',
            platform: 'web,ios'
          }
        }
      }
    }
  }
};
